(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["kit-purchase"] && !Shopify.designMode) return;
  try {
    // Kits with variants (e.g. Anua Plump DewTox Set): the product form already swaps the variant id; this refreshes
  // the kit price and the kit quick guide (every [data-kit-sync] element) from the section HTML of the new variant.
  document.addEventListener('shopify:product:select', (event) => {
    const section = event.target instanceof Element ? event.target.closest('.shopify-section') : null;
    if (!section || !section.querySelector('.kit-purchase')) return;
    Promise.resolve(event.promise).then((result) => {
      const html = result && result.detail && result.detail.html;
      if (!html) return;
      section.querySelectorAll('[data-kit-sync]').forEach((el) => {
        const fresh = html.querySelector('[data-kit-sync="' + el.dataset.kitSync + '"]');
        if (fresh) el.innerHTML = fresh.innerHTML;
      });
    }).catch(() => {});
  });
  } catch(e) { console.error(e); }
})();

})();
